<div class="element-dialog-container">
  <div class="dialog-header">
    <h2 mat-dialog-title>Element bearbeiten</h2>
    <button mat-icon-button (click)="onClose()" class="close-button" matTooltip="Schließen">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <mat-divider></mat-divider>

  <mat-tab-group animationDuration="0ms" (selectedTabChange)="onTabChanged($event)">
    <!-- Tab 1: Element Information -->
    <mat-tab label="Element Informationen">
      <mat-dialog-content class="dialog-content">
        <div class="content-layout">
          <!-- Image section -->
          <div class="image-section">
            <div class="image-container" [class.loading]="isImageLoading">
              <img *ngIf="!isImageLoading && (imageUrl || '/assets/PlaceholderContainuel.png')"
                   [src]="imageUrl || '/assets/PlaceholderContainuel.png'"
                   alt="Element Bild"
                   class="element-image">
              <div *ngIf="isImageLoading" class="loading-indicator">
                <mat-icon class="spinning">refresh</mat-icon>
              </div>
            </div>

            <div class="image-upload-container">
              <input type="file" id="fileInput" (change)="onImageUpload($event)" hidden>
              <button mat-raised-button color="primary" (click)="openFileInput()" [disabled]="isUploading">
                <mat-icon>cloud_upload</mat-icon>
                <span *ngIf="!isUploading">Bild hochladen</span>
                <span *ngIf="isUploading">Wird hochgeladen...</span>
              </button>
            </div>
          </div>

          <!-- Form section -->
          <div class="form-section">
            <div class="form-group">
              <h3 class="section-title">Grundinformationen</h3>

              <div class="form-row">
                <mat-form-field class="form-field" appearance="outline">
                  <mat-label>Name</mat-label>
                  <input matInput [(ngModel)]="data.element.name" placeholder="Elementname eingeben">
                  <mat-icon matSuffix>label</mat-icon>
                </mat-form-field>

                <mat-form-field class="form-field" appearance="outline">
                  <mat-label>ID</mat-label>
                  <input matInput [(ngModel)]="data.element.id" disabled>
                  <mat-icon matSuffix>fingerprint</mat-icon>
                </mat-form-field>
              </div>

              <mat-form-field class="form-field full-width" appearance="outline">
                <mat-label>Beschreibung</mat-label>
                <textarea matInput [(ngModel)]="data.element.description" rows="2"
                          placeholder="Beschreibung des Elements eingeben"></textarea>
                <mat-icon matSuffix>description</mat-icon>
              </mat-form-field>

              <div class="form-row">
                <mat-form-field class="form-field" appearance="outline">
                  <mat-label>Hersteller</mat-label>
                  <input matInput [(ngModel)]="data.element.hersteller" placeholder="Hersteller eingeben">
                  <mat-icon matSuffix>business</mat-icon>
                </mat-form-field>

                <mat-form-field class="form-field" appearance="outline">
                  <mat-label>Bestellnummer</mat-label>
                  <input matInput [(ngModel)]="data.element.bestellnumer" placeholder="Bestellnummer eingeben">
                  <mat-icon matSuffix>numbers</mat-icon>
                </mat-form-field>
              </div>
            </div>

            <mat-divider></mat-divider>

            <div class="form-group">
              <h3 class="section-title">Klassifikation</h3>

              <div class="form-row">
                <mat-form-field class="form-field" appearance="outline">
                  <mat-label>Kategorie</mat-label>
                  <input type="text" matInput [(ngModel)]="data.element.kategorie"
                         [matAutocomplete]="autoCategory" placeholder="Kategorie auswählen oder eingeben">
                  <mat-autocomplete #autoCategory="matAutocomplete">
                    <mat-option *ngFor="let category of categories" [value]="category">
                      {{category}}
                    </mat-option>
                  </mat-autocomplete>
                  <mat-icon matSuffix>category</mat-icon>
                </mat-form-field>

                <mat-form-field class="form-field" appearance="outline">
                  <mat-label>Zustand</mat-label>
                  <input matInput [(ngModel)]="data.element.zustand" placeholder="Zustand eingeben">
                  <mat-icon matSuffix>health_and_safety</mat-icon>
                </mat-form-field>
              </div>
            </div>

            <mat-divider></mat-divider>

            <div class="form-group">
              <h3 class="section-title">Lagerinformationen</h3>

              <div class="form-row">
                <mat-form-field class="form-field" appearance="outline">
                  <mat-label>Lager</mat-label>
                  <input type="text" matInput [(ngModel)]="data.element.lager"
                         [matAutocomplete]="autoLager" (ngModelChange)="onLagerChanged()"
                         placeholder="Lager auswählen oder eingeben">
                  <mat-autocomplete #autoLager="matAutocomplete">
                    <mat-option *ngFor="let warehouse of warehouses" [value]="warehouse">
                      {{warehouse}}
                    </mat-option>
                  </mat-autocomplete>
                  <mat-icon matSuffix>warehouse</mat-icon>
                </mat-form-field>

                <mat-form-field class="form-field" appearance="outline">
                  <mat-label>Lagerort</mat-label>
                  <input type="text" matInput [(ngModel)]="data.element.lagerort"
                         [matAutocomplete]="autoLagerort"
                         placeholder="Lagerort auswählen oder eingeben"
                         [disabled]="!data.element.lager">
                  <mat-autocomplete #autoLagerort="matAutocomplete">
                    <mat-option *ngFor="let location of locations" [value]="location">
                      {{location}}
                    </mat-option>
                  </mat-autocomplete>
                  <mat-icon matSuffix>place</mat-icon>
                </mat-form-field>
              </div>

             <mat-form-field class="form-field" appearance="outline">
              <mat-label>Menge</mat-label>
              <input matInput type="number" [(ngModel)]="data.element.quantity" min="0" placeholder="Menge eingeben" [disabled]="!data.iscopy" >
              <mat-icon matSuffix>inventory_2</mat-icon>
              <mat-hint>Bitte bei Entnahme die Entnahme Funktion verwenden</mat-hint>
            </mat-form-field>
            </div>
          </div>
        </div>
      </mat-dialog-content>
    </mat-tab>

    <!-- Tab 2: Entnahmehistorie -->
    <mat-tab label="Entnahmehistorie">
      <mat-dialog-content class="dialog-content">
        <div class="history-section">
          <h3>Entnahmehistorie</h3>

          <div class="loading-container" *ngIf="isLoadingHistory">
            <mat-spinner diameter="40"></mat-spinner>
          </div>

          <div class="no-history" *ngIf="!isLoadingHistory && withdrawalHistory.length === 0">
            <p>Keine Entnahmen für dieses Element vorhanden.</p>
          </div>

          <div class="table-container" *ngIf="!isLoadingHistory && withdrawalHistory.length > 0">
            <table mat-table [dataSource]="withdrawalHistory" matSort class="mat-elevation-z1 withdrawal-table">
              <!-- Timestamp Column -->
              <ng-container matColumnDef="timestamp">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Datum & Zeit</th>
                <td mat-cell *matCellDef="let item">{{ formatDate(item.timestamp) }}</td>
              </ng-container>

              <!-- User Name Column -->
              <ng-container matColumnDef="userName">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Benutzer</th>
                <td mat-cell *matCellDef="let item">{{ item.userName }}</td>
              </ng-container>

              <!-- Quantity Column -->
              <ng-container matColumnDef="quantity">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Menge</th>
                <td mat-cell *matCellDef="let item">{{ item.quantity }}</td>
              </ng-container>

              <!-- Purpose Column -->
              <ng-container matColumnDef="purpose">
                <th mat-header-cell *matHeaderCellDef>Zweck</th>
                <td mat-cell *matCellDef="let item">{{ item.purpose }}</td>
              </ng-container>

              <!-- Comments Column -->
              <ng-container matColumnDef="comments">
                <th mat-header-cell *matHeaderCellDef>Kommentare</th>
                <td mat-cell *matCellDef="let item">{{ item.comments }}</td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            </table>

            <mat-paginator [pageSizeOptions]="[5, 10, 25]" showFirstLastButtons></mat-paginator>
          </div>
        </div>
      </mat-dialog-content>
    </mat-tab>

    <!-- Tab 3: Element entnehmen -->
    <mat-tab label="Element entnehmen">
      <mat-dialog-content class="dialog-content">
        <div class="content-layout withdrawal-layout">
          <!-- Element info section -->
          <div class="element-info-section">
            <div class="element-info-card">
              <h3>Element Informationen</h3>
              <div class="info-row">
                <span class="info-label">Name:</span>
                <span class="info-value">{{ data.element.name }}</span>
              </div>
              <div class="info-row">
                <span class="info-label">ID:</span>
                <span class="info-value">{{ data.element.id }}</span>
              </div>
              <div class="info-row">
                <span class="info-label">Kategorie:</span>
                <span class="info-value">{{ data.element.kategorie }}</span>
              </div>
              <div class="info-row">
                <span class="info-label">Lager:</span>
                <span class="info-value">{{ data.element.lager }}</span>
              </div>
              <div class="info-row">
                <span class="info-label">Lagerort:</span>
                <span class="info-value">{{ data.element.lagerort }}</span>
              </div>
              <div class="info-row">
                <span class="info-label">Verfügbare Menge:</span>
                <span class="info-value">{{ data.element.quantity }}</span>
              </div>
            </div>
          </div>

          <!-- Withdrawal form section -->
          <div class="withdrawal-form-section">
            <h3>Entnahme registrieren</h3>
            <form [formGroup]="withdrawalForm" (ngSubmit)="onWithdraw()">
              <mat-form-field appearance="outline" class="full-width">
                <mat-label>Menge</mat-label>
                <input matInput type="number" formControlName="quantity" min="1" [max]="data.element.quantity">
                <mat-error *ngIf="withdrawalForm.get('quantity')?.hasError('required')">
                  Bitte geben Sie eine Menge an
                </mat-error>
                <mat-error *ngIf="withdrawalForm.get('quantity')?.hasError('min')">
                  Die Menge muss mindestens 1 sein
                </mat-error>
                <mat-error *ngIf="withdrawalForm.get('quantity')?.hasError('max')">
                  Die Menge darf nicht größer als der verfügbare Bestand ({{ data.element.quantity }}) sein
                </mat-error>
              </mat-form-field>

              <mat-form-field appearance="outline" class="full-width">
                <mat-label>Zweck der Entnahme</mat-label>
                <input matInput formControlName="purpose" placeholder="z.B. Projekt, Reparatur, etc.">
                <mat-error *ngIf="withdrawalForm.get('purpose')?.hasError('required')">
                  Bitte geben Sie einen Zweck an
                </mat-error>
              </mat-form-field>

              <mat-form-field appearance="outline" class="full-width">
                <mat-label>Kommentare (optional)</mat-label>
                <textarea matInput formControlName="comments" rows="2"></textarea>
              </mat-form-field>

              <div class="form-actions">
                <button mat-raised-button color="primary" type="submit" [disabled]="withdrawalForm.invalid || isWithdrawing">
                  <mat-icon>remove_shopping_cart</mat-icon>
                  Element entnehmen
                </button>
              </div>
            </form>
          </div>
        </div>
      </mat-dialog-content>
    </mat-tab>
  </mat-tab-group>

  <mat-divider></mat-divider>

  <mat-dialog-actions align="end" class="dialog-actions">
    <ng-container *ngIf="selectedTabIndex === 0">
      <button mat-button (click)="onClose()" class="cancel-button">
        <mat-icon>cancel</mat-icon> Abbrechen
      </button>
      <button mat-raised-button color="primary" (click)="onSave()" cdkFocusInitial>
        <mat-icon>save</mat-icon> Speichern
      </button>
    </ng-container>
    <ng-container *ngIf="selectedTabIndex !== 0">
      <button mat-button (click)="onClose()">
        <mat-icon>arrow_back</mat-icon> Schließen
      </button>
    </ng-container>
  </mat-dialog-actions>
</div>
